module.exports = __webpack_public_path__ + "img/ev.c2d29928.png";